"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StatisticsListTitle = void 0;
const react_1 = __importDefault(require("react"));
const ui_1 = require("../ui");
const common_1 = require("../../../common");
const GlobalStateProvider_1 = require("../../../GlobalStateProvider");
const USER_TYPE_DROPDOWN_LIST = [
    { id: '00', title: 'common.all' },
    { id: '01', title: 'common.host' },
    { id: '02', title: 'common.manager' },
    { id: '03', title: 'common.member' },
    { id: '04', title: 'common.admin' },
];
exports.StatisticsListTitle = react_1.default.memo(({ searchOption, userType, setSearchOption, setUserType, }) => {
    const { isTablet, isMobile } = (0, GlobalStateProvider_1.useGlobalState)();
    const [value, setValue] = react_1.default.useState(() => {
        const initial = USER_TYPE_DROPDOWN_LIST.find(item => item.id === userType);
        return initial || USER_TYPE_DROPDOWN_LIST[0];
    });
    const handlerUpdateDrop = (item) => {
        setValue(item);
        setUserType(item.id);
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(common_1.DropDown, { className: "dropdown-tablet-small", value: value, list: USER_TYPE_DROPDOWN_LIST, styles: {
                ...(isMobile ? {} : { dropWrap: { width: isTablet ? 120 : 150 } }),
                itemWrap: {
                    top: isTablet ? '50px' : '45px',
                },
            }, setDropValue: handlerUpdateDrop }),
        react_1.default.createElement(ui_1.SearchInput, { defaultValue: searchOption, setSearchOption: setSearchOption })));
});
